import { useState } from 'react';
import { Link } from 'react-router-dom';
import { allProjects, projectCategories } from '../../../mocks/projects';

export default function ProjectsGrid() {
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  const filteredProjects = selectedCategory === 'Todos'
    ? allProjects
    : allProjects.filter(project => project.industry === selectedCategory);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Category Filter */}
        <div className="mb-12 overflow-x-auto">
          <div className="flex gap-3 pb-4 min-w-max">
            {projectCategories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-orange-500 to-green-500 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <Link
              key={project.id}
              to={`/proyectos/${project.id}`}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer hover:-translate-y-2"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-4 py-2 bg-orange-500/90 text-white text-xs font-semibold rounded-full">
                    {project.industry}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="flex gap-4 text-white text-xs">
                      <div>
                        <div className="text-white/70">Eficiencia</div>
                        <div className="font-bold">{project.stats.efficiency}</div>
                      </div>
                      <div>
                        <div className="text-white/70">Tiempo</div>
                        <div className="font-bold">{project.stats.time}</div>
                      </div>
                      <div>
                        <div className="text-white/70">ROI</div>
                        <div className="font-bold">{project.stats.roi}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-500 transition-colors">
                  {project.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                  {project.description}
                </p>
                <div className="flex items-center justify-between">
                  <div className="text-xs text-gray-500">
                    {project.client} • {project.year}
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-gray-400 group-hover:text-orange-500 transition-colors"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {filteredProjects.length === 0 && (
          <div className="text-center py-16">
            <div className="w-20 h-20 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-4">
              <i className="ri-folder-open-line text-gray-400 text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              No hay proyectos en esta categoría
            </h3>
            <p className="text-gray-600">
              Prueba seleccionando otra categoría
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
